import { Box, styled } from '@mui/material';

const SelectWrapper = styled(Box)`
  min-width: 220px;
  width: max-content;
`;

export default SelectWrapper;
